/**
 * Tour demos - Main aggregator
 * Combines common demos with all module-specific demos
 */

import type { TourDemoType } from '../types'
import { getCommonDemoHTML } from './common-demos'
import { getDayoffDemoHTML } from '@/modules/Dayoffs/demos/tour-demos'
import { getBusinessDemoHTML } from '@/modules/Business/demos/tour-demos'
import { getCustomerDemoHTML } from '@/modules/Customer/demos/tour-demos'
import { getEmployeeDemoHTML } from '@/modules/Employee/demos/tour-demos'

/**
 * Generate demo HTML based on demo type
 * Tries all demo sources in order: common → dayoff → business → customer → employee
 */
export const getDemoHTML = (demo?: TourDemoType): string => {
    // Try each demo source
    return (
        getCommonDemoHTML(demo) ||
        getDayoffDemoHTML(demo) ||
        getBusinessDemoHTML(demo) ||
        getCustomerDemoHTML(demo) ||
        getEmployeeDemoHTML(demo) ||
        ''
    )
}

// Re-export individual demo functions for direct use if needed
export { getCommonDemoHTML } from './common-demos'
export { getDayoffDemoHTML } from '@/modules/Dayoffs/demos/tour-demos'
export { getBusinessDemoHTML } from '@/modules/Business/demos/tour-demos'
export { getCustomerDemoHTML } from '@/modules/Customer/demos/tour-demos'
export { getEmployeeDemoHTML } from '@/modules/Employee/demos/tour-demos'
